import type { ProductCreditCardConfig } from '../../@types/context/product-credit-card-config.types';

export const creditCardFiConfig: ProductCreditCardConfig = {
  config: {
    amount: {
      min: 500,
      max: 15_000,
      default: 5_000,
      step: 500,
    },
  },
};
